function userModel(param) {
    param = param || {};
    this.account = param.account || "";
    this.cellphone = param.cellphone || "";
    this.userid = param.userid || "";
    this.name = param.name || "";
    this.currentlogintime = param.currentlogintime || ""; //登录时间
    this.sessionid =param.sessionid || "";
    this.validtoken =param.validtoken || "";
    this.permissions =param.permissions || "";
    this.formid =param.formid || "";
}

let model = new userModel();

try {
    let cache = window.localStorage["userModel"];
    if (cache) {
        model = new userModel(JSON.parse(cache));
    }
} catch (e) {
    console.log("cache转化失败");
    alert("cache转化失败");
}

function cache() {
    try {
        let cache = window.localStorage["userModel"];
      
        if (cache) {
            model = new userModel(JSON.parse(cache));
        }
    } catch (e) {
        console.log("cache转化失败");
    }
}
let user = {
    // 创建新的用户对象
    init(param) {
        model = new userModel(param);
        window.localStorage["userModel"] = JSON.stringify(model);
    },
    // 清空用户对象
    clear() {
        model = new userModel();
        window
            .localStorage
            .removeItem("userModel");
        window
            .localStorage
            .removeItem("authorityList");
    },
    // 这个方法不要用,获取当前内存中的用户对象
    getModel() {
        if (model.account != "") {
            return model;
        }
        cache();
        return model;
    },
    setModel(newModel) {
        // console.log(newModel.__proto__.constructor);
        // console.log(userModel);
        if (newModel.__proto__.constructor == userModel) {
            model = newModel;
            window.localStorage["userModel"] = JSON.stringify(newModel);
        }
    },
    isLogin() {
        let account = model.account;
        if (account != "" && typeof account !== undefined && account != null) {
            return true;
        } else {
            return false;
        }
    },
    setBackUrl(url) {
        window.localStorage["backUrl"] = url;
    },
    getBackUrl() {
        return window.localStorage["backUrl"];
    },
    setData(key, value) {
        window.localStorage[key] = JSON.stringify(value);
    },
    getData(key) {
        try {
            return JSON.parse(window.localStorage[key]);
        } catch (e) {
            return null;
        }
    },
    clearData(key) {
        window.localStorage.removeItem(key);
    }
};
export default user;


// WEBPACK FOOTER //
// ./src/model/userModel.js